<div class="usp-list-container">
  <p>{{ VASProductName }}</p>
  <ul>
    @for (usp of uniqueSellingPoints; track usp + $index) {
      <li>
        {{ usp }}
      </li>
    }
  </ul>
</div>
